import { render } from "./AddLearnerRecord.vue?vue&type=template&id=8e8582bc&scoped=true"
import script from "./AddLearnerRecord.vue?vue&type=script&lang=js"
export * from "./AddLearnerRecord.vue?vue&type=script&lang=js"

import "./AddLearnerRecord.vue?vue&type=style&index=0&id=8e8582bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e8582bc"]])

export default __exports__